import storage from 'good-storage'

const BASE_INFO = '__baseInfo__'
const PRODUCTION_INFO = '__productionInfo__'
const SHARE_BASE_INFO = '__shareBaseInfo__'
const CYCLE_INFO = '__cycleInfo__'
const BLOCK_INFO = '__blockChainInfo__'

export function getBaseInfo () {
  return storage.get(BASE_INFO)
}

export function saveBaseInfo (baseInfo) {
  storage.set(BASE_INFO, baseInfo)
}

export function getProductionInfo () {
  return storage.get(PRODUCTION_INFO)
}

export function saveProductionInfo (prodInfo) {
  storage.set(PRODUCTION_INFO, prodInfo)
}

export function getShareBaseInfo () {
  return storage.get(SHARE_BASE_INFO)
}

export function saveShareBaseInfo (baseInfo) {
  storage.set(SHARE_BASE_INFO, baseInfo)
}

export function getCycleInfo () {
  return storage.get(CYCLE_INFO)
}

export function saveCycleInfo (info) {
  storage.set(CYCLE_INFO, info)
}

export function getBlockChainInfo () {
  return storage.get(BLOCK_INFO)
}

export function saveBlockChainInfo (info) {
  storage.set(BLOCK_INFO, info)
}

export function removeBlockChainInfo () {
  storage.remove(BLOCK_INFO)
}



// WEBPACK FOOTER //
// ./src/utils/cache.js